import * as React from "react";
import { Card, Stack } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export default function PartCard({
  part = {},
  onClick,
  showPrice = false,
  showPerPound = false,
  localImage = false,
}) {
  const { 
    price = 0, 
    minPrice = 0, 
    maxPrice = 0, 
    partNumber = '', 
    image1 = null 
  } = part || {};

  return (
    <Card sx={{ marginTop: "10px", borderRadius: "10px" }} onClick={onClick}>
      <CardActionArea>
        <CardContent
          sx={{ backgroundColor: '#000', color: "#24e4ff" }}
        >
          <Stack
            direction="row"
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            {image1 && (
              <CardMedia
                component="img"
                height="50"
                sx={{ width: "50px" }}
                image={
                  localImage
                    ? `${process.env.PUBLIC_URL}/${image1}`
                    : `https://s3.us-east-2.amazonaws.com/366images/${image1}`
                }
                alt={partNumber}
              />
            )}
            {showPrice && (
              <Typography
                variant="h5"
                sx={{
                  color: "#24e4ff",
                  fontWeight: 700,
                }}
              >
                ${parseFloat(price || minPrice).toFixed(2)} {showPerPound && "/lb"}
              </Typography>
            )}
            <Typography
              gutterBottom
              sx={{ fontWeight: 500, fontSize: "18px" }}
              component="div"
            >
              {partNumber}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
